<!-- 学校画像 -->
<template>
  <div class="s-portrait">
    <!-- 标题 -->
    <div class="s-header">
      <div class="s-header-title">
        梧桐中学心理画像
      </div>
      <div class="s-header-years">
        2022-2023学年第一学期
      </div>
    </div>
    <!-- 内容 -->
    <div class="s-content">
      <!-- 左侧 -->
      <div class="s-left">
        <div class="s-left-top">
          <div class="s-label">
            应用概况
          </div>
          <div class="s-box">
            <div class="s-cont-title">
              减压星球
            </div>
            <div class="s-cont-time s-cont-margin">
              {{ overviewObject.evaluationRate }} 人次
            </div>
            <div class="s-cont-text s-cont-margin">
              {{ overviewObject.evaluationName }}
            </div>
            <div class="s-cont-box">
              <div class="s-box-li">
                <div class="s-cont-text s-cont-margin">
                  {{ overviewObject.interveneName }}
                </div>
                <div class="s-cont-time">
                  {{ overviewObject.interveneRate }} 人次
                </div>
              </div>
              <div class="s-cont-bg">
                <div class="s-cont-bg-box">
                  <div class="s-cont-bg-text">
                    个人
                  </div>
                  <div class="s-cont-bg-text">
                    心理画像
                  </div>
                  <div>{{ overviewObject.totalNum }} 人次</div>
                </div>
              </div>
              <div class="s-box-li">
                <div class="s-cont-text s-cont-margin">
                  {{ overviewObject.earlyName }}
                </div>
                <div class="s-cont-time">
                  {{ overviewObject.earlyRate }} 人次
                </div>
              </div>
            </div>
            <div class="s-cont-bottom">
              分层干预
            </div>
          </div>
        </div>
        <div class="s-left-bottom">
          <div class="s-label">
            应用趋势
          </div>
          <div class="s-box">
            <div class="s-mode-list">
              <div
                v-for="(it, index) in applicationList"
                :key="index"
                :class="['s-mode-li', {active :it.value === applicationSatus}]"
                @click="changeApplication(it)"
              >
                {{ it.name }}
              </div>
            </div>
            <ul class="s-list-times">
              <li
                v-for="(it, index) in timesList"
                :key="index"
                class="s-mode-li"
                :class="[{active: timesStatus === it.value}, 's-mode-li']"
                @click="changeDaysLine(it.value)"
              >
                {{ it.name }}
              </li>
            </ul>
            <div
              v-if="applicationSatus==1"
              id="applicationLine"
              style="width: 2.42188rem; height: 1.65104rem;"
            />
            <div
              v-if="applicationSatus==2"
              id="applicationBar"
              style="width: 2.42188rem; height: 1.65104rem;"
            />
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="s-center">
        <!-- 校园覆盖概况 -->
        <div class="s-survey">
          <div class="s-survey-itle">
            <img
              src="@/assets/images/center-title.png"
              alt="icon"
            >
            <span class="title">校园覆盖概况</span>
            <img
              src="@/assets/images/center-title.png"
              alt="icon"
            >
          </div>
          <div class="s-survey-list">
            <div class="s-survey-li">
              <div class="s-survey-box">
                <div class="s-survey-num">
                  {{ coverObject.warningNum }}
                </div>
                <div class="s-survey-proportion">
                  <span :class="['s-survey-icon', coverObject.warningStatus? 'top': 'down']" />
                  <span>{{ coverObject.warningPercentage }}</span>
                </div>
              </div>
              <div class="s-survey-box">
                <div class="s-survey-lable">
                  {{ coverObject.warningLabel }}
                </div>
                <div class="s-survey-text">
                  {{ coverObject.warningTimes }}
                </div>
              </div>
            </div>
            <div class="s-survey-li">
              <div class="s-survey-box">
                <div class="s-survey-tips">
                  {{ coverObject.anxiousText }}
                </div>
              </div>
              <div class="s-survey-box">
                <div class="s-survey-lable">
                  {{ coverObject.anxiousLabel }}
                </div>
                <div class="s-survey-text">
                  {{ coverObject.anxiousTimes }}
                </div>
              </div>
            </div>
            <div class="s-survey-li">
              <div class="s-survey-box">
                <div class="s-survey-num">
                  {{ coverObject.InterventionNum }}
                </div>
                <div class="s-survey-proportion">
                  <span :class="['s-survey-icon', coverObject.InterventionStatus? 'top': 'down']" />
                  <span>{{ coverObject.InterventionPercentage }}</span>
                </div>
              </div>
              <div class="s-survey-box">
                <div class="s-survey-lable">
                  {{ coverObject.InterventionLabel }}
                </div>
                <div class="s-survey-text">
                  {{ coverObject.InterventionTimes }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 智慧心育 -->
        <div class="s-center-box">
          <div class="s-center-intelligent intelligent-first">
            <div class="s-intell-label">
              <span class="s-intell-label-text">{{ intelligentPressureObj.intelligentName }}</span>
            </div>
            <div class="s-intell-text">
              昨日有 {{ intelligentPressureObj.intelligentNum }} 名学生完成智能干预
            </div>
          </div>
          <div class="s-center-intelligent intelligent-second">
            <div class="s-intell-label yell-color">
              <span class="s-intell-label-text">{{ intelligentPressureObj.pressureName }}</span>
            </div>
            <div class="s-intell-text">
              昨日有 {{ intelligentPressureObj.pressureNum }} 名学生完成测评
            </div>
          </div>
          <div class="s-center-main" />
        </div>
        <div class="s-center-table">
          <!-- 表头 -->
          <div class="s-table-header s-table">
            <div class="s-table-li" />
            <div
              v-for="(it, index) in tableHeader"
              :key="index"
              class="s-table-li"
            >
              {{ it.name }}
            </div>
          </div>
          <div
            v-for="(it, index) in tableBody"
            :key="index"
            class="s-table-body"
          >
            <div class="s-body-cont">
              <div class="s-table-li s-li-list">
                <div :class="['s-li-rate', {red: it.waring}]">
                  {{ it.statusNum }}
                </div>
                <div class="s-li-label">
                  {{ it.label }}
                </div>
                <div :class="['s-li-text', {red: it.waring}]">
                  <span>{{ it.waring ? '-': '+' }}</span>
                  {{ it.status }}
                </div>
              </div>
              <div class="s-table-li">
                <span class="s-table-icon one" />
                <span :class="['s-table-arrow', it.lightStatus? 'table-top': 'table-down']" />
                {{ it.light }}
              </div>
              <div class="s-table-li">
                <span class="s-table-icon two" />
                <span :class="['s-table-arrow', it.moderateStatus? 'table-top': 'table-down']" />
                {{ it.moderate }}
              </div>
              <div class="s-table-li">
                <span class="s-table-icon three" />
                <span :class="['s-table-arrow', it.severeStatus? 'table-top': 'table-down']" />
                {{ it.severe }}
              </div>
              <div class="s-table-li">
                <span class="s-table-icon four" />
                {{ it.coverage }}
              </div>
            </div>
            <div class="s-table-tips">
              {{ it.tips }}
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="s-right">
        <div class="s-right-top">
          <div class="s-label">
            心理素养
          </div>
          <div class="s-box">
            <ul class="s-list-times">
              <li
                v-for="(it, index) in academicSection"
                :key="index"
                class="s-mode-li"
                :class="[{active: accomplishmentStatus === it.value}, 's-mode-li']"
                @click="accomplishmentStatus = it.value"
              >
                {{ it.name }}
              </li>
            </ul>
            <div
              id="accomplishmentPie"
              style="width: 2.42188rem; height: 1.64004rem;"
            />
          </div>
        </div>
        <div class="s-right-bottom">
          <div class="s-label">
            分层关注
          </div>
          <div class="s-box">
            <div class="s-list-times">
              <div
                v-for="(it, index) in academicSection"
                :key="index"
                class="s-mode-li"
                :class="[{active: layeredStatus === it.value}, 's-mode-li']"
                @click="layeredStatus = it.value"
              >
                {{ it.name }}
              </div>
            </div>
            <!-- 柱子 -->
            <div class="s-lists">
              <div
                v-for="(it, index) in layeredAttention"
                :key="index"
                class="s-mode-li s-mode-type"
              >
                <span :class="['border', classMethods(it.leave)]" />
                <span class="border-text">{{ it.name }}</span>
              </div>
            </div>
            <!-- 提示 -->
            <div class="s-type-list">
              <div
                v-for="(it, index) in layeredAttention"
                :key="index"
                :style="`width: ${it.value}%`"
                class="s-type-list-li"
              >
                <div :class="['s-type-li', classMethods(it.leave)]" />
                <div
                  v-if="activeLayerStatus === it.leave"
                  class="s-type-li"
                >
                  <!-- <span :class="[, classBorder(it.leave)]" /> -->
                  <span class="s-type-shape" />
                  <span class="s-type-label">{{ it.name }}{{ it.rate }}</span>
                </div>
              </div>
            </div>
            <div class="s-class-status">
              班级情况
            </div>
            <table class="s-table-data">
              <thead class="s-data-header">
                <tr>
                  <th class="ellipsis">
                    班级名称
                  </th>
                  <th class="ellipsis">
                    关注等级
                  </th>
                  <th class="ellipsis">
                    关注主题
                  </th>
                  <th class="ellipsis">
                    干预建议
                  </th>
                </tr>
              </thead>
              <tbody class="s-data-body">
                <tr
                  v-for="(it, index) in classList"
                  :key="index"
                >
                  <th class="ellipsis">
                    {{ it.className }}
                  </th>
                  <th class="s-data-body-center">
                    <span :class="['s-data-li', classMethods(it.leave)]" />
                  </th>
                  <th class="ellipsis">
                    {{ it.label }}
                  </th>
                  <th class="ellipsis">
                    {{ it.tips }}
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 跳转链接 -->
    <!-- <div
      class="link-router  right-top"
      @click="$router.push('/knowledge')"
    /> -->
    <div
      class="link-router right-bottom"
      @click="$router.push('/measure/inventoryList')"
    />
  </div>
</template>

<script>
import {
  applicationLineEachers,
  applicationBarEachers,
  pieEcharts
} from './schoolPicEachers'
import { schoolPic } from '@/assets/data'
console.log(schoolPic, 'data')
export default {
  props: {},
  data () {
    return {
      overviewObject: schoolPic.overviewObject,
      intelligentPressureObj: schoolPic.intelligentPressureObj,
      applicationList: schoolPic.applicationList,
      applicationSatus: schoolPic.applicationSatus,
      timesList: schoolPic.timesList,
      timesStatus: schoolPic.timesStatus,
      dataNameFirst: schoolPic.dataNameFirst, // 使用频次近7天的X轴数据
      lineDataFirst: schoolPic.lineDataFirst,
      timesDataFirst: schoolPic.timesDataFirst,
      dataNameSecond: schoolPic.dataNameSecond, // 使用频次近7天的X轴数据
      lineDataSecond: schoolPic.lineDataSecond,
      timesDataSecond: schoolPic.timesDataSecond,
      dataNameThree: schoolPic.dataNameThree, // 使用频次近7天的X轴数据
      lineDataThree: schoolPic.lineDataThree,
      timesDataThree: schoolPic.timesDataThree,
      useingDataFirst: schoolPic.useingDataFirst,
      useingDataSecond: schoolPic.useingDataSecond,
      useingDataThree: schoolPic.useingDataThree,
      academicSection: schoolPic.academicSection,
      tableHeader: schoolPic.tableHeader,
      tableBody: schoolPic.tableBody,
      layeredAttention: schoolPic.layeredAttention,
      activeLayerStatus: schoolPic.activeLayerStatus,
      classList: schoolPic.classList,
      coverObject: schoolPic.coverObject,
      accomplishmentStatus: schoolPic.accomplishmentStatus,
      layeredStatus: schoolPic.layeredStatus,
      same_week: [],//今天前1周的数据
    }
  },
  computed: {
    // dataName () {
    //   return this.timesStatus === 1 ? this.dataNameFirst : this.timesStatus === 2 ? this.dataNameSecond : this.dataNameThree
    // },
    // lineData () {
    //   return this.timesStatus === 1 ? this.lineDataFirst : this.timesStatus === 2 ? this.lineDataSecond : this.lineDataThree
    // },
    // timesData () {
    //   return this.timesStatus === 1 ? this.timesDataFirst : this.timesStatus === 2 ? this.timesDataSecond : this.timesDataThree
    // },
    // useingData () {
    //   return this.timesStatus === 1 ? this.useingDataFirst : this.timesStatus === 2 ? this.useingDataSecond : this.useingDataThree
    // }
  },
  created () {

    // //设置日期，当前日期的前七天 
    // var myDate = new Date();
    // var myYear = myDate.getFullYear();
    // //获取今天日期 
    // myDate.setDate(myDate.getDate() - 7);
    // var dateArray = [];
    // var dateTemp;
    // var flag = 1;
    // for (var i = 0; i < 7; i++) {
    //   dateTemp = myYear + "/" + (myDate.getMonth() + 1) + "/" + myDate.getDate();
    //   dateArray.push(dateTemp);
    //   myDate.setDate(myDate.getDate() + flag);
    // }
    // console.log('前777777777');
    // console.log(dateArray);
    // console.log(myYear);
  },
  mounted () {
    this.$nextTick(() => {
      applicationLineEachers(this.$echarts, this.dataNameFirst, this.lineDataFirst, this.timesDataFirst)
      pieEcharts(this.$echarts)
    })
  },
  methods: {
    /** @applicationSatus 1 使用频次 2 使用时长 
     * @timesStatus 应用趋势 1 近7天 2 近一个月 3 近3个月 */
    changeApplication (it) {
      this.timesStatus = 1
      this.applicationSatus = it.value
      this.changeEcharts(1)
    },
    changeDaysLine (it) {
      this.timesStatus = it
      // this.changeEcharts()
    },
    changeEcharts (status) {
      if (this.applicationSatus === 1) {
        if (status) {
          let echartsMain = this.$echarts.init(document.getElementById("applicationBar"));
          if (echartsMain) {
            echartsMain.dispose();
          }
        }
        this.$nextTick(() => {
          applicationLineEachers(this.$echarts, this.dataNameFirst, this.lineDataFirst, this.timesDataFirst)
        })
      } else {
        if (status) {
          let echartsMain = this.$echarts.init(document.getElementById("applicationLine"));
          if (echartsMain) {
            echartsMain.dispose();
          }
        }
        this.$nextTick(() => {
          applicationBarEachers(this.$echarts, this.useingDataFirst)
        })
      }
    },
    classMethods (it) {
      let arrClass = ['one', 'two', 'three', 'four']
      return arrClass[it - 1]
    },
    classBorder (it) {
      let arrClass = ['oneBoder', 'twoBoder', 'threeBoder', 'fourBoder']
      return arrClass[it - 1]
    },




  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.s-portrait {
  position: relative;
  padding: 13px 24px 32px;
  width: 1920px;
  height: 1080px;
  box-sizing: border-box;
  color: #fff;
  background: url('~@/assets/images/bg.png') no-repeat;
  background-size: cover;
}
.link-router {
  position: fixed;
  right: 0;
  width: 100px;
  height: 100px;
  opacity: 0;
  background: #409eff;
  &.right-top {
    top: 0;
  }
  &.right-bottom {
    bottom: 0;
  }
}
.s-header {
  margin-bottom: 61px;
  padding: 0 24px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  position: relative;
  .s-header-years {
    position: absolute;
    top: 0px;
    right: -3px;
    width: 157px;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 24px;
  }
  .s-header-title {
    font-size: 44px;
    font-family: PangMenZhengDao;
    color: #ffffff;
    font-weight: bold;
    line-height: 50px;
    text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
    background: linear-gradient(180deg, #eef7ff 0%, #c5e5ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.s-content {
  display: flex;
  height: calc(100vh - 156px);
}
.s-label {
  padding-left: 32px;
  margin-bottom: 24px;
  height: 30px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
}
.s-box {
}
.s-left,
.s-right {
  width: 501px;
}
.s-left-top {
  margin-bottom: 31px;
  height: 444px;
  background: url('~@/assets/images/top-left.png') no-repeat;
  background-size: 100% 100%;
  .s-cont-title {
    // width: 80px;
    // height: 20px;
    margin-bottom: 40px;
    font-size: 20px;
    font-family: PangMenZhengDao;
    color: #ffffff;
    text-align: center;
    line-height: 23px;
    letter-spacing: 1px;
    background: linear-gradient(180deg, #ffffff 0%, #b3dbff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .s-cont-box {
    display: flex;
    align-items: flex-end;
    margin-bottom: 4px;
  }
  .s-box-li {
    width: calc(219px / 2);
  }
  .s-cont-bg {
    width: 282px;
    height: 236px;
    background: url('~@/assets/images/left-top-center.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    .s-cont-bg-box {
      position: absolute;
      top: 123px;
      left: 107px;
    }
    .s-cont-bg-text {
      text-align: center;
      width: 57px;
      line-height: 17px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      &:nth-child(2) {
        margin-bottom: 17px;
      }
    }
  }
  .s-cont-text {
    font-size: 16px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #ffffff;
    line-height: 14px;
    text-align: center;
  }
  .s-cont-time {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #c0cfff;
    line-height: 14px;
    text-align: center;
  }
  .s-cont-margin {
    margin-bottom: 7px;
  }
  .s-cont-bottom {
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #a7b7e9;
    line-height: 14px;
  }
}
.s-left-bottom {
  height: 459px;
  background: url('~@/assets/images/top-left.png') no-repeat;
  background-size: 100% 100%;

  #applicationLine,
  #applicationBar {
    width: 465px;
    height: 317px;
    padding: 0 18px;
  }
}
.s-mode-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 1px;
  background: linear-gradient(180deg, #ffffff 0%, #b3dbff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  overflow: hidden;
  .s-mode-li {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 101px;
    height: 38px;
    font-size: 14px;
    cursor: pointer;
  }
  .active {
    background: url('~@/assets/images/tab-hover.png') no-repeat;
  }
}
.s-list-times {
  padding: 0 18px;
  text-align: center;
  .s-mode-li {
    cursor: pointer;
    text-align: center;
    display: inline-block;
    width: 88px;
    height: 30px;
    line-height: 28px;
    background: linear-gradient(
      180deg,
      rgba(11, 56, 134, 0.07) 0%,
      #083d9c 100%
    );
    color: rgba(255, 255, 255, 0.45);
    border-radius: 1px;
    border: 1px solid;
    border-image: linear-gradient(
        184deg,
        rgba(52, 107, 166, 0.45),
        rgba(27, 139, 255, 0.45)
      )
      1 1;
  }
  .active {
    background: linear-gradient(
      180deg,
      rgba(7, 67, 171, 0.08) 0%,
      #0544b4 100%
    );
    color: #ffffff;
    font-weight: bold;
    border-radius: 1px;
    border: 1px solid rgba(4, 137, 255, 1);
  }
}
.s-center {
  margin: 0 42px;
  width: 786px;
  .s-center-box {
    position: relative;
    width: 100%;
    height: 428px;
  }
  .s-center-intelligent {
    display: inline-block;
    position: absolute;
    z-index: 8;
    &.intelligent-first {
      top: 68px;
      left: 182px;
      animation: bounce-down 1.8s linear infinite;
    }
    &.intelligent-second {
      top: 168px;
      left: 458px;
      animation: bounce-down 1.8s linear infinite;
    }
    @-webkit-keyframes bounce-down {
      25% {
        -webkit-transform: translateY(-10px);
      }
      50% {
        -webkit-transform: translateY(0px);
      }
      75% {
        -webkit-transform: translateY(6px);
      }
    }
  }
  .s-intell-label {
    margin: 0 auto 5px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #12ffdd;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    &.yell-color {
      background: #ffe371;
    }
    .s-intell-label-text {
      width: 40px;
      height: 48px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 24px;
      display: inline-block;
    }
  }
  .s-intell-text {
    padding: 0 12px;
    height: 28px;
    line-height: 28px;
    background: rgba(0, 0, 0, 0.42);
    border-radius: 14px;
  }
  .s-center-main {
    position: absolute;
    top: -65px;
    left: 50%;
    transform: translateX(-50%);
    width: 622px;
    height: 530px;
    background: url('~@/assets/images/center-main.png') no-repeat;
    background-size: 100% 100%;
  }
  .s-center-table {
    padding: 11px 20px 16px;
    width: 786px;
    height: 348px;
    background: rgba(9, 25, 87, 0.6);
    border-radius: 8px;
    border: 1px solid rgba(11, 116, 224, 0.49);
  }
  .s-survey {
    position: relative;
    padding-top: 12px;
  }
  .s-survey-itle {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    .title {
      padding: 0 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 16px;
      letter-spacing: 4px;
    }
  }
  // height: calc(100vh - 55px);
  .s-survey-list {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: url('~@/assets/images/sector-bg.png') no-repeat;
    background-size: 100% 100%;
    width: 745px;
    height: 148px;
    margin: 0 20px;
    .s-survey-li {
      display: flex;
    }
    .s-survey-box:nth-child(1) {
      margin-right: 8px;
    }
    .s-survey-num {
      margin: 0 0 7px 0;
      width: 100%;
      height: 20px;
      font-size: 20px;
      text-align: center;
      font-family: PangMenZhengDao;
      color: #ffffff;
      line-height: 23px;
      letter-spacing: 1px;
    }
    .s-survey-proportion {
      height: 14px;
      font-size: 14px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      line-height: 14px;
      &.blue {
        color: #0eff00;
      }
      &.red {
        color: #ff3c3c;
      }
      .s-survey-icon {
        margin-right: 6px;
        width: 8px;
        height: 12px;
        display: inline-block;
        &.top {
          background: url('~@/assets/images/top-icon.png') no-repeat;
        }
        &.down {
          background: url('~@/assets/images/down-icon.png') no-repeat;
        }
      }
    }
    .s-survey-tips {
      text-align: center;
      width: 57px;
      // height: 40px;
      font-size: 20px;
      font-family: PangMenZhengDao;
      color: #ff9a63;
      line-height: 23px;
      font-weight: bold;
      letter-spacing: 1px;
      background: linear-gradient(186deg, #ff9007 0%, #ff884c 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .s-survey-lable {
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 24px;
    }
    .s-survey-text {
      font-size: 14px;
      color: #c0cfff;
    }
  }
  .s-table {
    display: flex;
  }
  .s-table-header {
    height: 33px;
    line-height: 33px;
    background: #081f7d;
    border-radius: 4px;
  }
  .s-body-cont {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    height: 57px;
    // line-height: 56px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  }
  .s-table-tips {
    margin-bottom: 5px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a7b7e9;
    line-height: 16px;
  }
  .s-table-li {
    width: 113px;
    display: inline-block;
    font-size: 14px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #ffffff;
    &:nth-of-type(1) {
      width: 303px;
      display: inline-block;
    }
    > div {
      display: inline-block;
    }
    .s-li-rate {
      margin-right: 12px;
      width: 66px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      background: #12ffdd;
      border-radius: 4px;
      color: #000000;
      font-weight: bold;
      &.red {
        background: #ff5f5f;
        color: #fff;
      }
    }
    .s-li-label {
      margin-right: 12px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 16px;
    }
    .s-li-text {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #12ffdd;
      line-height: 14px;
      &.red {
        color: #ff5f5f;
      }
    }
    .s-table-icon {
      margin: 0 8px 2px 0;
      display: inline-block;
      width: 22px;
      height: 8px;
      border-radius: 5px;
      &.one {
        background: #ffaa2a;
      }
      &.two {
        background: #8029ff;
      }
      &.three {
        background: #ff3c3c;
      }
      &.four {
        background: #12ffdd;
      }
    }
    .s-table-arrow {
      margin-right: 4px;
      display: inline-block;
      width: 8px;
      height: 12px;
      &.table-down {
        background: url('~@/assets/images/table-down.png') no-repeat;
      }
      &.table-top {
        background: url('~@/assets/images/table-top.png') no-repeat;
      }
    }
  }
}
.s-right-top {
  margin-bottom: 32px;
  height: 406px;
  background: url('~@/assets/images/right-bg.png') no-repeat;
  background-size: 100% 100%;
  .s-label {
    margin-bottom: 31px;
  }
}
.s-right-bottom {
  margin-bottom: 24px;
  height: 504px;
  background: url('~@/assets/images/right-bottom.png') no-repeat;
  background-size: 100% 100%;
  .s-label {
    margin-bottom: 40px;
  }
  .s-box {
    padding: 0 20px 13px;
  }
  .s-list-times {
    margin-bottom: 24px;
  }
}
.s-lists {
  margin: 0 0 14px 0;
  text-align: right;
  .s-mode-li {
    margin-right: 16px;
    display: inline-block;
    &:nth-child(4) {
      margin-right: 0;
    }
  }
  .border {
    display: inline-block;
    width: 11px;
    height: 2px;
    margin-right: 8px;
  }
  .border-text {
    vertical-align: sub;
  }
}
.s-type-list {
  display: flex;
  height: 50px;
  margin-bottom: 10px;
  .s-type-list-li {
    .s-type-li {
      height: 8px;
      position: relative;
    }
    &:nth-child(1) .s-type-li {
      border-radius: 12px 0 0 12px;
    }
    &:nth-child(4) .s-type-li {
      border-radius: 0 12px 12px 0;
    }
  }
}
.s-class-status {
  margin-bottom: 11px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 14px;
}
.s-type-shape {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-bottom: 6px solid #fff;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
.s-type-label {
  position: absolute;
  top: 24px;
  left: 50%;
  text-align: center;
  transform: translateX(-50%);
  width: 86px;
  height: 14px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a7b7e9;
  line-height: 14px;
}
.one {
  background: #12ffdd;
}
.two {
  background: #ffaa2a;
}
.three {
  background: #9145ff;
}
.four {
  background: #ff6d73;
}
.oneBoder {
  border-bottom-color: #12ffdd;
}
.twoBoder {
  border-bottom-color: #ffaa2a;
}
.threeBoder {
  border-bottom-color: #9145ff;
}
.fourBoder {
  border-bottom-color: #ff6d73;
}
.s-table-data {
  width: 460px;
  height: 250px;
  background: linear-gradient(180deg, rgba(7, 67, 171, 0.08) 0%, #0544b4 100%);
  // border: 1px solid;
  border-image: linear-gradient(
      185deg,
      rgba(52, 107, 166, 0),
      rgba(8, 129, 255, 0.41)
    )
    1 1;
  th {
    padding: 0 12px;
    font-size: 14px;
  }
  .s-data-header {
    // width: 100%;
    height: 36px;
    background: url('~@/assets/images/table-header-bg.png') no-repeat;
    background-size: 100% 100%;
  }
  .s-data-body {
    height: 199px;
    overflow-y: auto;
    .s-data-body-center {
      text-align: center;
    }
    tr {
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid rgba(86, 163, 241, 0.17);
      &:nth-last-child(1) {
        border-bottom: 0;
      }
    }
  }
}
.s-data-li {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
